import { Grid, FormControlLabel, Checkbox } from '@mui/material';

const TabNine = ({
  setOthers,
  others,
  onClickAll,
  isEdit
}) => {
  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <FormControlLabel
          id="others-form-all"
          control={
            <Checkbox
              id="others-all"
              checked={others.every((dash) => dash.value)}
              onClick={(e) => onClickAll(others, 'common', setOthers, e)}
              disabled={isEdit}
            />
          }
          label="All"
        />
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'Received' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'Sent' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}></Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'Add Feedback' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
    </Grid>
  );
};

export default TabNine;
